<template>
  <div class="statistics">
    <div class="header">
      <div class="l">
        <div class="label">
          目标对象
        </div>
        <el-select
          v-model="searchForm.agentId"
          placeholder="请选择代理商"
          clearable
        >
          <el-option
            v-for="item in agentList"
            :key="item.id"
            :label="item.agentName"
            :value="item.id"
          />
        </el-select>
        <el-select
          v-model="searchForm.userId"
          placeholder="请选择代理人员"
          clearable
        >
          <el-option
            v-for="item in userList"
            :key="item.userId"
            :label="item.showName"
            :value="item.userId"
          />
        </el-select>
      </div>
      <div class="r">
        <div class="label">
          查询纬度
        </div>
        <el-select
          v-model="searchForm.statisticsDimension"
          placeholder="请选择代理商状态"
        >
          <el-option
            v-for="item in statisticsDimensionList"
            :key="item.statisticsDimension"
            :label="item.label"
            :value="item.statisticsDimension"
          />
        </el-select>
        <el-date-picker
          v-model="searchForm.statisticsStartDt"
          type="date"
          placeholder="选择开始时间"
          value-format="timestamp"
        />
        <el-date-picker
          v-model="searchForm.statisticsEndDt"
          type="date"
          placeholder="选择开始时间"
          value-format="timestamp"
        />
        <el-button
          type="primary"
          @click="getHomePageStatistics()"
        >
          查询统计
        </el-button>
      </div>
    </div>
    <tabContent
      :panel-data="result"
      :query-type.sync="queryType"
      @elementClick="elementClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import tabContent from './panel/index.vue';

export default {
  name: 'Home',
  components: {
    tabContent,
  },
  data() {
    return {
      searchForm: {
        statisticsStartDt: this.$time().startOf('month'),
        statisticsEndDt: this.$time().endOf('month').add(1, 'day'),
        statisticsDimension: 10,
        agentId: null,
        userId: null,
      },
      queryType: 10,
      agentList: [],
      statisticsDimensionList: [
        {
          statisticsDimension: 10,
          label: '年',
        },
        {
          statisticsDimension: 20,
          label: '月',
        },
        {
          statisticsDimension: 30,
          label: '日',
        },
      ],
      result: [],
    };
  },
  computed: {
    userList() {
      if (this.searchForm.agentId) {
        return this.agentList.filter((v) => v.id === this.searchForm.agentId)[0].userList;
      }
      return [];
    },
  },
  watch: {
    queryType() {
      this.getHomePageStatistics();
    },
  },
  mounted() {
    this.getAgentList();
    this.getHomePageStatistics();
  },
  methods: {
    // 跳转到对应路由
    elementClick() {
      if (this.queryType === 10) {
        this.$router.push({
          name: 'AgencyList',
          query: {
            startTime: this.$time(this.searchForm.statisticsStartDt).valueOf(),
            endTime: this.$time(this.searchForm.statisticsEndDt).valueOf(),
            agentId: this.searchForm.agentId,
            agentUserId: this.searchForm.userId,
          },
        });
      } else {
        this.$router.push({
          name: 'RegistrationProcessList',
          query: {
            startTime: this.$time(this.searchForm.statisticsStartDt).valueOf(),
            endTime: this.$time(this.searchForm.statisticsEndDt).valueOf(),
            agentId: this.searchForm.agentId,
            agentUserId: this.searchForm.userId,
          },
        });
      }
    },
    // 获取列表
    async getHomePageStatistics() {
      this.result = [];
      const res = await axClient.agent.agentListStatistics({ ...this.searchForm, queryType: this.queryType });
      if (res && res.length > 0) {
        res.forEach((item) => {
          if (item.statisticList && item.statisticList.length > 0) {
            item.statisticList.forEach((statistic) => {
              if (this.queryType === 30) {
                statistic.yvalue /= 100;
              }
              this.result.push(statistic);
            });
          }
        });
      }
    },
    // 获取列表
    async getAgentList() {
      this.agentList = await axClient.agent.agentListAllName();
    },
  },
};
</script>
<style lang="scss" scoped>
.statistics{
  padding-top: 10px;
  .header{
    .el-select{
      max-width: 150px;
      margin-left: 20px;
    }
    .el-date-editor{
      max-width: 150px;
      margin-left: 20px;
    }
  }
}
</style>
